import { __assign, __rest } from "tslib";
import React from 'react';
import classNames from 'classnames';
import { Select } from '@tencent/tea-component/lib/select';
export function BuyOperationSelect(_a) {
    var options = _a.options, rest = __rest(_a, ["options"]);
    var operationOptions = options.map(function (_a) {
        var value = _a.value, type = _a.type, args = __rest(_a, ["value", "type"]);
        return (__assign({ text: (React.createElement("div", { className: "buy-list-item" },
                React.createElement("i", { className: classNames('buy-icon', "buy-icon-" + type.toLowerCase()) }),
                React.createElement("span", { className: "list-text" }, type))), value: value }, args));
    });
    return React.createElement(Select, __assign({}, rest, { options: operationOptions }));
}
//# sourceMappingURL=BuyOperationSelect.js.map